//
// Copyright (c) 2011-2025 by Curalate, Inc.
//

import { SocialNetwork } from '@models/SocialNetwork';

const CommonEngagementFields = ['likes', 'comments'] as const;
const NetworkEngagementFields: Partial<
  Record<SocialNetwork, readonly string[]>
> = {
  [SocialNetwork.Instagram]: ['saves', 'shares'] as const,
};

export const getEngagementFieldNames = (socialNetwork: SocialNetwork) => {
  return [
    ...CommonEngagementFields,
    ...(NetworkEngagementFields[socialNetwork] ?? []),
  ];
};
